import React, { Component } from "react";
import { Editor } from "./react-draft-wysiwyg";
import { Modifier, ContentState, convertToRaw, EditorState, RichUtils } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "./react-draft-wysiwyg/index.css";
import MergeTagOption from "./MergeTagOption";
import { insertNewUnstyledBlock } from "draftjs-utils";
import { getSelectedBlock } from "draftjs-utils";
import { List } from "immutable";

const toolbarStyle = {
  position: "sticky",
  top: 0,
  zIndex: 10
};

const toolbarOptions = {
  options: [
    "inline",
    "blockType",
    "fontSize",
    "fontFamily",
    "list",
    "textAlign",
    "colorPicker",
    "link",
    "emoji",
    "remove",
    "history"
  ],

  inline: { inDropdown: true },
  list: { inDropdown: true },
  textAlign: { inDropdown: true },
  link: { inDropdown: true },
  history: { inDropdown: true },
  fontFamily: {
    options: [
      "Arial",
      "Arial Black",
      "Book Antiqua",
      "Georgia",
      "Impact",
      "Tahoma",
      "Calibri",
      "Comic Sans MS",
      "Courier New",
      "Times New Roman",
      "Verdana",
      "Geneva",
      "Helvetica",
      "Lucida Console",
      "Lucida Grande",
      "Lucida Sans Unicode",
      "Open Sans",
      "Segoe Script",
      "Trebuchet MS"
    ]
  }
};
class EditorIFrame extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      htmlData: "",
      mergeTags: []
    };
    this.blockRenderer = this.blockRenderer.bind(this);
    this.customEntityTransform = this.customEntityTransform.bind(this);
    this.handlePastedText = this.handlePastedText.bind(this);
  }

  componentDidMount() {
    window.addEventListener("message", this.receiver, false);
    window.parent.postMessage({ type: "EDITOR_LOADED", textEditorLoaded: true }, "*");
  }

  blockRenderer = (block) => {
    const { htmlData } = this.state;
    if (block.getType() === "atomic") {
      const contentState = htmlData.getCurrentContent();
      const entityKey = block.getEntityAt(0);
      if (entityKey) {
        const entity = contentState.getEntity(entityKey);
        if (entity && entity.type === "HORIZONTAL_RULE") {
          return {
            component: () => <hr style={{ backgroundColor: "#D3D3D3", opacity: "0.8", border: "0", height: "1px" }} />,
            editable: false
          };
        }

        if (entity && entity.type === "LOCK_FOLLOWUP_DIV_RULE" && entity.data.id === "followupContentLocked") {
          return {
            component: () => (
              <div id="followupContentLocked" dangerouslySetInnerHTML={{ __html: entity.data.innerHTML }} />
            ),
            editable: false
          };
        }
      }
    }
    return undefined;
  };

  customEntityTransform = (entity, text) => {
    if (entity.type === "HORIZONTAL_RULE") {
      // eslint-disable-next-line consistent-return
      return `<hr style="background-color:#D3D3D3;opacity: 0.8;border:0;height:1px" />`;
    } else if (entity.type === "LOCK_FOLLOWUP_DIV_RULE") {
      return `<div id="followupContentLocked">${entity.data.innerHTML}</div>`;
    }
    return;
  };

  receiver = (e) => {
    console.log("receiver in child");
    let postData = e.data;
    if (postData) {
      const id = postData.id;
      console.log(`post message : ${JSON.stringify(postData)}`);
      if (postData.type === "GET_DATA") {
        window.parent.postMessage(
          {
            type: "GET_DATA",
            htmlData: draftToHtml(
              convertToRaw(this.state.htmlData.getCurrentContent()),
              {},
              false,
              this.customEntityTransform
            ),
            id
          },
          "*"
        );
      } else if (postData.type === "SET_DATA") {
        const contentBlock = htmlToDraft(postData.htmlData, (nodeName, node) => {
          //creating custom atomic block
          if (nodeName === "hr") {
            return {
              type: "HORIZONTAL_RULE",
              mutability: "MUTABLE",
              data: {}
            };
          }
          if (nodeName === "div" && node && node.id === "followupContentLocked") {
            debugger;
            return {
              type: "LOCK_FOLLOWUP_DIV_RULE",
              mutability: "MUTABLE",
              data: {
                id: node.id,
                innerText: node.innerText,
                innerHTML: node.innerHTML
              }
            };
          }
        });
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          const editorState = EditorState.createWithContent(contentState);
          this.setState({ htmlData: editorState });
        }
      } else if (postData.type === "MERGE_TAGS") {
        this.setState({ mergeTags: postData.mergetags });
      }
    }
  };
  onChange = (editorState) => {
    this.setState({ htmlData: editorState });
  };

  handlePastedText = (text, html, editorState, onChange) => {
    console.log(text, html);
    const selectedBlock = getSelectedBlock(editorState);
    if (selectedBlock && selectedBlock.type === "code") {
      const contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        text,
        editorState.getCurrentInlineStyle()
      );
      onChange(EditorState.push(editorState, contentState, "insert-characters"));
      return true;
    } else if (html) {
      html = html.replace(/<i([^>]*)>/g, "<em$1>").replace(/<\/i>/g, "</em>"); //replacing i with em
      html = html.replace(/<b([^>]*)>(.*?)<\/b>/g, "<strong$1>$2</strong>"); //replacing b with strong

      // Define regular expression to find font sizes specified in em, rem, or pt units
      const fontSizeRegex = /font-size:\s*([\d.]+)(em|rem|pt);/g;
      // Replace font sizes specified in em, rem, or pt units with pixels (px)
      html = html.replace(fontSizeRegex, (match, value, unit) => {
        let pxValue;
        if (unit === "pt") {
          pxValue = parseFloat(value) * 1.33333333333; // Convert pt to px
        } else {
          pxValue = parseFloat(value) * 16; // Convert em or rem to px
        }
        return `font-size: ${pxValue}px;`;
      });
      const contentBlock = htmlToDraft(html);
      let contentState = editorState.getCurrentContent();
      contentBlock.entityMap.forEach((value, key) => {
        contentState = contentState.mergeEntityData(key, value);
      });
      contentState = Modifier.replaceWithFragment(
        contentState,
        editorState.getSelection(),
        new List(contentBlock.contentBlocks)
      );
      onChange(EditorState.push(editorState, contentState, "insert-characters"));
      return true;
    }
    return false;
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        <Editor
          editorState={this.state.htmlData}
          onEditorStateChange={this.onChange}
          toolbarStyle={toolbarStyle}
          toolbar={toolbarOptions}
          blockRendererFn={this.blockRenderer}
          toolbarCustomButtons={[<MergeTagOption onChange={this.onChange} mergeTagsData={this.state.mergeTags} />]}
          handlePastedText={this.handlePastedText}
        />
      </div>
    );
  }
}

export default EditorIFrame;
